// source: pbtypes/gen/calibration/auto_focus_data_point.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.calibration.AutoFocusDataPoint', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.calibration.AutoFocusDataPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.calibration.AutoFocusDataPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.calibration.AutoFocusDataPoint.displayName = 'proto.calibration.AutoFocusDataPoint';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.calibration.AutoFocusDataPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.calibration.AutoFocusDataPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.calibration.AutoFocusDataPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.calibration.AutoFocusDataPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
inverseRange: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
actuatorPosition: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
temperature: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.calibration.AutoFocusDataPoint}
 */
proto.calibration.AutoFocusDataPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.calibration.AutoFocusDataPoint;
  return proto.calibration.AutoFocusDataPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.calibration.AutoFocusDataPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.calibration.AutoFocusDataPoint}
 */
proto.calibration.AutoFocusDataPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setInverseRange(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setActuatorPosition(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTemperature(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.calibration.AutoFocusDataPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.calibration.AutoFocusDataPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.calibration.AutoFocusDataPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.calibration.AutoFocusDataPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInverseRange();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getActuatorPosition();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getTemperature();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
};


/**
 * optional double inverse_range = 1;
 * @return {number}
 */
proto.calibration.AutoFocusDataPoint.prototype.getInverseRange = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.calibration.AutoFocusDataPoint} returns this
 */
proto.calibration.AutoFocusDataPoint.prototype.setInverseRange = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double actuator_position = 2;
 * @return {number}
 */
proto.calibration.AutoFocusDataPoint.prototype.getActuatorPosition = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.calibration.AutoFocusDataPoint} returns this
 */
proto.calibration.AutoFocusDataPoint.prototype.setActuatorPosition = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double temperature = 3;
 * @return {number}
 */
proto.calibration.AutoFocusDataPoint.prototype.getTemperature = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.calibration.AutoFocusDataPoint} returns this
 */
proto.calibration.AutoFocusDataPoint.prototype.setTemperature = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


goog.object.extend(exports, proto.calibration);
